import { FAQType_Child } from './types.js';
export const cleanFAQ = Object.freeze({
    label: 'New FAQ',
    type: FAQType_Child,
    answer: '',
    __faqIds: [],
});
//# sourceMappingURL=consts.js.map